import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();
  const { userRole } = useAuth();

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card border-warning">
            <div className="card-body text-center">
              <i className="fas fa-exclamation-triangle text-warning fa-4x mb-4"></i>
              <h2 className="card-title text-warning">Access Denied</h2>
              <p className="card-text">
                You don't have permission to access this page.
              </p>
              <p className="text-muted">
                Your current role: <strong>{userRole?.toUpperCase() || 'UNKNOWN'}</strong>
              </p>

              <div className="mt-4">
                <button
                  className="btn btn-primary me-2"
                  onClick={() => navigate('/dashboard')}
                >
                  <i className="fas fa-home me-1"></i>
                  Go to Dashboard
                </button>
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => navigate(-1)}
                >
                  <i className="fas fa-arrow-left me-1"></i>
                  Go Back
                </button>
              </div>

              <div className="mt-4">
                <div className="alert alert-info">
                  <i className="fas fa-info-circle me-2"></i>
                  If you believe you should have access to this page,
                  please contact your administrator.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
